import React, { useContext, useRef, useState } from "react";
import PhotoModal from "../../components/Modals/PhotoModal";
import { isDesktop } from "react-device-detect";
import { CustomImageCapture } from "../../components";
import {
  notify,
  manageErrorLogs,
  checkCatchMessage,
  checkSystemWebcam,
  compressMediaFiles,
  getLocationCoordinates,
} from "../../helpers/commonFunction";
import { messages } from "../../helpers/messages";
import PhotoDetailsModal from "../../components/Modals/PhotoDetailsModal";
import { useCachedLocation } from "../../hooks";
import { insertTakeDetailsInDB } from "./DBQuery";
import LocalDBContext from "../../helpers/LocalDBContext";

const TakeDetails = () => {
  const inputRef = useRef(null);
  const webcamRef = useRef(null);
  const { setIsDataChanged } = useContext(LocalDBContext);
  const { position, accuratePosition } = useCachedLocation();
  const [selfieData, setSelfieData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selfiesList, setSelfiesList] = useState([]);
  const [photoPreviewModal, setPhotoPreviewModal] = useState(false);
  const [takeDetailsModal, setTakeDetailsModal] = useState(false);
  const [isOtherSelfie, setIsOtherSelfie] = useState(false);
  const handlePhotoPreviewModal = () => {
    setPhotoPreviewModal(!photoPreviewModal);
    if (isOtherSelfie) {
      setSelfieData(null);
      setIsOtherSelfie(false);
      setTakeDetailsModal(true);
    } else {
      setSelfieData(null);
      setSelfiesList([]);
    }
  };
  const handleErasePreviewSelfieData = () => {
    if (isOtherSelfie) {
      setIsOtherSelfie(false);
      setTakeDetailsModal(true);
    } else {
      inputRef.current.click();
      setSelfieData(null);
    }
    setPhotoPreviewModal(false);
  };

  const openSelfieModal = async (isOther) => {
    await checkSystemWebcam()
      .then(() => {
        if (isDesktop) {
        } else {
          if (inputRef && inputRef.current) {
            inputRef.current.value = "";
          }
          if (isOther) {
            setIsOtherSelfie(true);
          }
          inputRef.current.click();
        }
      })
      .catch(() => {});
  };

  const handleGetSelfie = async (event) => {
    try {
      if (isDesktop) {
        const imageSrc = webcamRef?.current?.getScreenshot();
        if (!imageSrc) {
          throw new Error(messages.errors.captureImg);
        }
        setSelfieData(imageSrc);
      } else {
        const files = event?.target?.files;
        if (!files || (Array.isArray(files) && files?.length === 0)) {
          throw new Error(messages.errors.captureImg);
        }
        const base64 = await compressMediaFiles(files[0], "file", "selfie");
        setSelfieData(base64);
        setPhotoPreviewModal(true);
        if (isOtherSelfie) {
          setTakeDetailsModal(false);
        }
      }
    } catch (error) {
      manageErrorLogs(error);
      checkCatchMessage(error?.message || messages.errors.capture_selfie);
    }
  };

  const handleUsePhoto = () => {
    setSelfiesList((prev) => [
      ...prev,
      { image_url: null, base64: selfieData },
    ]);
    setIsOtherSelfie(false);
    setPhotoPreviewModal(false);
    setTakeDetailsModal(true);
  };

  const handleSubmitTakeDetails = async (data) => {
    try {
      setIsLoading(true);
      let address = "";
      if (accuratePosition || position) {
        address = accuratePosition || position;
      } else {
        const getCoord = await getLocationCoordinates().catch(() => "");
        address = getCoord || accuratePosition || position || null;
      }
      if (
        !Array.isArray(selfiesList) ||
        selfiesList?.length === 0 ||
        selfiesList?.some((item) => !item?.base64?.includes("base64"))
      ) {
        throw new Error(
          "Something went wrong while converting the image to a base64!"
        );
      }
      const reqObj = {
        ...data,
        address: null,
        latitude: address?.latitude || null,
        longitude: address?.longitude || null,
        images: selfiesList,
      };
      await insertTakeDetailsInDB(reqObj);
      setIsDataChanged((prev) => ({ ...prev, takedDetails: true }));
      notify("Details submitted successfully!", "success");
      setIsLoading(false);
      setSelfieData(null);
      setSelfiesList([]);
      setTakeDetailsModal(false);
      setPhotoPreviewModal(false);
    } catch (error) {
      setIsLoading(false);
      manageErrorLogs(error);
      checkCatchMessage(
        error?.message || "Something went wrong in take details!"
      );
    }
  };

  return (
    <>
      <div className="take-photo-container">
        <div className="logo-box">
          <span className="logo-title-red">Rx Agad</span>
          <br />
          <span className="logo-title-green">F.O.G System</span>
        </div>
        <div
          className="photo-button"
          onClick={() => openSelfieModal()}
          style={{ cursor: "pointer" }}
        >
          <span className="photo-button-take">Take</span>
          <span className="photo-button-photo">PHOTO</span>
        </div>
      </div>
      {photoPreviewModal && (
        <PhotoModal
          show={photoPreviewModal}
          onHide={handlePhotoPreviewModal}
          selfieData={selfieData}
          isOtherSelfie={isOtherSelfie}
          takeDetailsModal={takeDetailsModal}
          onErase={handleErasePreviewSelfieData}
          onSubmit={() => handleUsePhoto()}
        />
      )}
      {takeDetailsModal && (
        <PhotoDetailsModal
          show={takeDetailsModal}
          onHide={() => !isLoading && setTakeDetailsModal(false)}
          selfiesList={selfiesList}
          isOtherSelfie={isOtherSelfie}
          onSubmit={handleSubmitTakeDetails}
          isLoading={isLoading}
          openSelfieModal={openSelfieModal}
        />
      )}
      {!isDesktop && (
        <CustomImageCapture
          inputRef={inputRef}
          handleFileChange={handleGetSelfie}
        />
      )}
    </>
  );
};

export default TakeDetails;
